require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-fleet-luxury-sub.json") })
        }
      }, "path---en-fleet-luxury-sub");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-fleet-luxury-sub!./.cache/json/en-fleet-luxury-sub.json
// module id = 1033
// module chunks = 231608221292675